import "./App.css";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CaseStudies from "./components/CaseStudies";
import Dashboard from "./components/Dashboard";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";

const DEMO = [
  {
    content:
      "Portal Kartini — campaign KPIs, channel split, regional participation and realtime trend view.",
    title: "Portal Kartini",
    val: "portal",
    disabled: false,
  },
  {
    content:
      "Dompet Kartini — campaign KPIs, channel split, regional participation and realtime trend view.",
    title: "Dompet Kartini",
    val: "dompet",
    disabled: true,
  },
  {
    content:
      "RECEIPT IR DEMO — receipt image, extracted fields, confidence state, retailer mapping and eligibility logic.",
    title: "Receipt IR",
    val: "receipt",
    disabled: true,
  },
  {
    content:
      "DISPLAY IR DEMO — shelf image, detection overlay, quantity, compliance result and exception summary.",
    title: "Display IR",
    val: "display",
    disabled: true,
  },
];

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState("home");
  const [homeKey, setHomeKey] = useState(0);
  const newsSliderRef = useRef(null);

  const platformRef = useRef(null);
  const technologyRef = useRef(null);
  const newsRef = useRef(null);
  const customersRef = useRef(null);
  const foundersRef = useRef(null);

  const homeSectionRefs = {
    platform: platformRef,
    technology: technologyRef,
    news: newsRef,
    customers: customersRef,
    founders: foundersRef,
  };

  const scrollToHomeSection = (sectionId) => {
    showPage("home");
    window.requestAnimationFrame(() => {
      homeSectionRefs[sectionId]?.current?.scrollIntoView({ behavior: "smooth" });
    });
  };

  function showPage(id, sectionId) {
    document.querySelectorAll(".page").forEach((p) => p.classList.remove("active"));
    document.getElementById(id).classList.add("active");
    setCurrentPage(id);
    if (id === "home") setHomeKey((k) => k + 1);

    window.requestAnimationFrame(() => {
      if (sectionId) {
        const sectionElement =
          id === "home"
            ? homeSectionRefs[sectionId]?.current || document.getElementById(sectionId)
            : document.getElementById(sectionId);
        sectionElement?.scrollIntoView({ behavior: "smooth" });
        return;
      }

      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }
  function showMarket(m, ev) {
    const img = document.getElementById("marketPreviewImage");
    const map = {
      malaysia: "https://cdn.kar-tini.id/malaysia_4ef74d425c.png",
      philippines: "https://cdn.kar-tini.id/philippines_133b10aef3.png",
    };
    if (img) {
      img.src = map[m] || "Malaysia.png";
      img.alt = (m === "philippines" ? "Philippines" : "Malaysia") + " Market Map";
    }
    document.querySelectorAll(".market-btn").forEach((b) => b.classList.remove("dark"));
    if (ev && ev.target) ev.target.classList.add("dark");
  }
  function switchChannel(c, ev) {
    const img = document.getElementById("channelImage");
    const copy = document.getElementById("channelCopy");
    const map = {
      whatsapp: "https://cdn.kar-tini.id/whatsapp_af59ff604f.png",
      messenger: "https://cdn.kar-tini.id/messanger_ed3d310f6d.png",
      viber: "https://cdn.kar-tini.id/viber_5d6db31a74.png",
    };
    img.src = map[c] || "https://cdn.kar-tini.id/whatsapp_af59ff604f.png";
    const text = {
      whatsapp:
        "WhatsApp is ideal for promotional chatbots because of its massive global user base, high message open rates, and native interactive features such as buttons, lists, and location sharing that simplify shopper engagement journeys.",
      messenger:
        "Messenger works well for conversational marketing because it integrates seamlessly with Facebook and Instagram ecosystems, allowing brands to convert social traffic directly into chatbot interactions and personalized promotions.",
      viber:
        "Viber is widely used in several international markets and offers strong business messaging capabilities, making it effective for brands running localized promotions, loyalty programs, and community-driven engagement.",
    };
    if (copy) {
      copy.textContent = text[c] || text.whatsapp;
    }
    document.querySelectorAll(".channel").forEach((b) => b.classList.remove("primary"));
    if (ev && ev.target) ev.target.classList.add("primary");
  }
  const [demoType, setDemoType] = useState("portal");

  const switchDemo = (type) => {
    setDemoType(type);
  };

  function switchWA(type, ev) {
    const label = document.getElementById("waModuleLabel");
    const caption = document.getElementById("waCaption");
    const thread = document.getElementById("waThread");
    const data = {
      voucher: {
        label: "Digital Voucher Distribution",
        caption:
          "Preview how Kartini guides shoppers through a digital voucher redemption journey using a conversational interface.",
        html: '<div class="wa-bubble left">Welcome! Would you like to claim today’s promotion?</div><div class="wa-bubble right">Yes, show me the available offers.</div><div class="wa-bubble left">Please select a participating product and nearby store to continue.</div>',
      },
      gwp: {
        label: "Gift With Purchase",
        caption:
          "Show how Gift With Purchase mechanics can be explained, validated and redeemed within a simple messaging flow.",
        html: '<div class="wa-bubble left">Buy 2 participating products and receive an exclusive gift.</div><div class="wa-bubble right">How do I claim it?</div><div class="wa-bubble left">Upload your receipt and we will validate your purchase automatically.</div>',
      },
      loyalty: {
        label: "Loyalty Points",
        caption:
          "Demonstrate how Kartini can support repeat engagement through points accumulation and redemption journeys.",
        html: '<div class="wa-bubble left">Your latest purchase has been verified. You earned 120 loyalty points.</div><div class="wa-bubble right">What can I redeem with that?</div><div class="wa-bubble left">You can exchange points for vouchers, gifts or campaign rewards.</div>',
      },
      vdd: {
        label: "Visibility and Distribution Drive",
        caption:
          "Present how field execution and retail participation can also be supported through structured messaging prompts.",
        html: '<div class="wa-bubble left">Please confirm your store execution for this Visibility and Distribution Drive task.</div><div class="wa-bubble right">I have completed the display upload.</div><div class="wa-bubble left">Thank you. Your submission is being reviewed and will appear in your report view.</div>',
      },
    };
    const item = data[type];
    label.textContent = item.label;
    caption.textContent = item.caption;
    thread.innerHTML = item.html;
    document.querySelectorAll(".wa-tab").forEach((b) => b.classList.remove("active"));
    if (ev && ev.target) ev.target.classList.add("active");
  }
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
          }
        });
      },
      { threshold: 0.12 },
    );

    const elements = document.querySelectorAll(".reveal");
    elements.forEach((el) => io.observe(el));

    return () => io.disconnect();
  }, []);

  useEffect(() => {
    const sectionId = location.state?.scrollTo;
    if (!sectionId) {
      return;
    }

    showPage("home", sectionId);
    navigate(location.pathname, { replace: true, state: null });
  }, [location, navigate]);

  return (
    <>
      <Navbar onShowPage={showPage} onSectionSelect={scrollToHomeSection} />
      <div id="home" className="page active">
        <main>
          <section className="wrap hero section-loose reveal">
            <div>
              <div className="eyebrow first">Promotion Infrastructure for Modern FMCG</div>
              <h1>
                Connect brands, retailers and shoppers through one intelligent promotion platform.
              </h1>
              <p style={{ fontSize: "16px" }}>
                Kartini enables companies to deploy nationwide consumer and trade promotions, verify
                retail execution using Image Recognition, and monitor campaign performance through a
                unified analytics environment.
              </p>
              <div className="hero-actions">
                <button className="btn dark" onClick={() => showPage("demo")}>
                  Book Demo
                </button>
                <button className="btn" onClick={() => scrollToHomeSection("platform")}>
                  Explore Platform
                </button>
              </div>
            </div>
            <div className="stage reveal">
              <div className="center">
                <strong style={{ fontSize: "28px" }}>Kartini</strong>
                <small>Promotion orchestration · verification · analytics</small>
              </div>
              <div className="card" style={{ top: "28px", left: "20px" }}>
                <small>BRANDS</small>
                <strong>Campaign Command Center</strong>
                <span>
                  Configure promotion mechanics, eligible products, retail coverage and reporting
                  views.
                </span>
              </div>
              <div className="card" style={{ top: "78px", right: "20px" }}>
                <small>SHOPPERS</small>
                <strong>Conversational Engagement</strong>
                <span>
                  Acquire and guide shoppers through promotions using familiar messaging
                  experiences.
                </span>
              </div>
              <div className="card" style={{ bottom: "28px", left: "20px" }}>
                <small>RETAILERS</small>
                <strong>Dompet Kartini Verification</strong>
                <span>Verify vouchers, upload receipts and manage store-level execution.</span>
              </div>
              <div className="card" style={{ bottom: "86px", right: "20px" }}>
                <small>IMAGE RECOGNITION</small>
                <strong>Display IR · Receipt IR</strong>
                <span>Automatically validate shelf displays and purchase receipts.</span>
              </div>
              <div className="signal-path signal-a"></div>
              <div className="signal-path signal-b"></div>
              <div className="signal-path signal-c"></div>
              <div className="signal-path signal-d"></div>
              {/* <div className="signal-node n1"></div>
              <div className="signal-node n2"></div>
              <div className="signal-node n3"></div>
              <div className="signal-node n4"></div> */}
            </div>
          </section>
          <section className="wrap section-tight reveal">
            <div className="logo-marquee">
              <div className="logo-track">
                <div className="logo-item">
                  <img src="https://cdn.kar-tini.id/abbott_8ad3d08ebf.jpeg" alt="Abbott" />
                </div>
                <div className="logo-item">
                  <img src="https://cdn.kar-tini.id/reckit_7c14d3c6f3.jpeg" alt="Reckitt" />
                </div>
                <div className="logo-item">
                  <img src="https://cdn.kar-tini.id/bayer_03527184db.png" alt="Bayer" />
                </div>
                <div className="logo-item">
                  <img src="https://cdn.kar-tini.id/pringles_aeea1b217e.png" alt="Pringles" />
                </div>
                <div className="logo-item">
                  <img src="https://cdn.kar-tini.id/wyeth_9ffa53b90a.png" alt="Wyeth" />
                </div>
                {/* <div className="https://cdn.kar-tini.id/kraftheinz_307b3d11d8.png">
                  <img src="KHI logo.png" alt="Kraft Heinz" />
                </div>
                <div className="https://cdn.kar-tini.id/kalbe_11af68b158.png">
                  <img src="Kalbe Logo.png" alt="Kalbe" />
                </div>
                <div className="https://cdn.kar-tini.id/p_and_g_9ca3391f6f.png">
                  <img src="P&G Logo.png" alt="P&G" />
                </div> */}
                <div className="logo-item">
                  <img src="https://cdn.kar-tini.id/mayora_4ad4aa0073.png" alt="Mayora" />
                </div>
                <div className="logo-item">
                  <img src="https://cdn.kar-tini.id/nestle_93c821b0b0.png" alt="Nestle" />
                </div>
                <div className="logo-item">
                  <img src="https://cdn.kar-tini.id/unilever_d03afa290c.png" alt="Unilever" />
                </div>
                <div className="logo-item">
                  <img src="https://cdn.kar-tini.id/abbott_fdb22f9854.jpeg" alt="Abbott" />
                </div>
                <div className="logo-item">
                  <img src="https://cdn.kar-tini.id/reckit_7c14d3c6f3.jpeg" alt="Reckitt" />
                </div>
                <div className="logo-item">
                  <img src="https://cdn.kar-tini.id/bayer_03527184db.png" alt="Bayer" />
                </div>
                <div className="logo-item">
                  <img src="https://cdn.kar-tini.id/pringles_aeea1b217e.png" alt="Pringles" />
                </div>
                <div className="logo-item">
                  <img src="https://cdn.kar-tini.id/wyeth_9ffa53b90a.png" alt="Wyeth" />
                </div>
                <div className="logo-item">
                  <img src="https://cdn.kar-tini.id/kraftheinz_307b3d11d8.png" alt="Kraft Heinz" />
                </div>
                <div className="logo-item">
                  <img src="https://cdn.kar-tini.id/kalbe_11af68b158.png" alt="Kalbe" />
                </div>
                <div className="logo-item">
                  <img src="https://cdn.kar-tini.id/p_and_g_9ca3391f6f.png" alt="P&G" />
                </div>
                <div className="logo-item">
                  <img src="https://cdn.kar-tini.id/mayora_4ad4aa0073.png" alt="Mayora" />
                </div>
                <div className="logo-item">
                  <img src="https://cdn.kar-tini.id/nestle_93c821b0b0.png" alt="Nestle" />
                </div>
                <div className="logo-item">
                  <img src="https://cdn.kar-tini.id/unilever_d03afa290c.png" alt="Unilever" />
                </div>
              </div>
            </div>
          </section>
          <section className="wrap reveal">
            <div className="head">
              <div>
                <div className="eyebrow">Recognition & Trust</div>
                <h2>Recognized for innovation, execution and enterprise-grade security.</h2>
              </div>
              <p>
                Kartini is trusted by brands and industry partners across Southeast Asia. Our
                platform combines operational scale with security and governance standards expected
                by global FMCG organizations.
              </p>
            </div>
            <div className="grid3">
              <div className="panel badge-card">
                <div>
                  <div className="badge-kicker">CyberVadis</div>
                  <div className="badge-value">Gold Certification for CyberSecurity</div>
                </div>
                <p>
                  Recognition of Kartini’s commitment to robust cybersecurity governance and
                  operational risk management.
                </p>
              </div>
              <div className="panel badge-card">
                <div>
                  <div className="badge-kicker">Marketing Interactive</div>
                  <div className="badge-value">Best Consumer Campaign</div>
                </div>
                <p>
                  Awarded for delivering impactful shopper engagement campaigns through digital
                  promotion technology.
                </p>
              </div>
              <div className="panel badge-card">
                <div>
                  <div className="badge-kicker">WhatsApp</div>
                  <div className="badge-value">Official Business Solution Provider</div>
                </div>
                <p>
                  Kartini integrates directly with WhatsApp Business capabilities to power
                  large-scale shopper engagement journeys.
                </p>
              </div>
            </div>
          </section>
          <section className="wrap reveal">
            <div className="head">
              <div>
                <div className="eyebrow">Why Kartini</div>
                <h2>Promotions are still fragmented. Execution should not be.</h2>
              </div>
              <p>
                Kartini unifies campaign deployment, shopper engagement, retailer participation,
                Image Recognition verification and performance reporting in one connected
                environment.
              </p>
            </div>
            <div className="grid4">
              <div className="panel">
                <h3>Faster Deployment</h3>
                <p>
                  Launch consumer and trade promotion programs without relying on disconnected tools
                  and manual coordination.
                </p>
              </div>
              <div className="panel">
                <h3>Stronger Verification</h3>
                <p>
                  Validate receipts, shelf execution and retailer activity through structured
                  workflows and Image Recognition outputs.
                </p>
              </div>
              <div className="panel">
                <h3>Unified Visibility</h3>
                <p>
                  Monitor redemption, participation, compliance and campaign health from a single
                  reporting layer.
                </p>
              </div>
              <div className="panel">
                <h3>Retail Readiness</h3>
                <p>
                  Support retailers with smoother redemption, reimbursement and store-level
                  execution processes.
                </p>
              </div>
            </div>
          </section>
          <section className="wrap section-loose reveal">
            <div className="head">
              <div>
                <div className="eyebrow">Regional Presence</div>
                <h2>Operating across Southeast Asia with proven market execution.</h2>
              </div>
              <p>
                Kartini is already supporting promotion programs and retail execution initiatives in
                Indonesia, Malaysia and the Philippines, helping brands deploy scalable engagement
                infrastructure across multiple markets.
              </p>
            </div>
            <div className="markets">
              <div className="panel">
                <button className="btn dark market-btn" onClick={(e) => showMarket("malaysia", e)}>
                  Malaysia
                </button>
                <div style={{ height: "8px" }}></div>
                <button className="btn market-btn" onClick={(e) => showMarket("philippines", e)}>
                  Philippines
                </button>
                <p style={{ marginTop: "14px", color: "#666" }}>
                  Click a market to preview implementation examples.
                </p>
                <div className="market-badge" style={{ marginTop: "14px" }}>
                  Indonesia
                  <span>
                    Primary operating base with deep retail and shopper activation capability.
                  </span>
                </div>
              </div>
              <div
                className="panel"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "420px",
                  overflow: "hidden",
                }}
              >
                <img
                  id="marketPreviewImage"
                  src="https://cdn.kar-tini.id/malay_becdd27e59.png"
                  alt="Malaysia Market Map"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "380px",
                    objectFit: "contain",
                    display: "block",
                  }}
                />
              </div>
            </div>
          </section>
          <section className="wrap reveal">
            <div className="head">
              <div>
                <div className="eyebrow">Channel Flexibility</div>
                <h2>Designed for the messaging platforms your customers already use.</h2>
              </div>
              <p>
                Deploy promotions, engage shoppers and distribute rewards through the messaging apps
                people interact with daily. Kartini works across widely used messaging ecosystems so
                brands can activate campaigns without requiring consumers to install new
                applications.
              </p>
            </div>
            <div className="grid3">
              <div
                className="panel"
                style={{
                  gridColumn: "span 2",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "520px",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    height: "520px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    id="channelImage"
                    src="https://cdn.kar-tini.id/whatsapp_af59ff604f.png"
                    alt="Channel Preview"
                    style={{
                      maxWidth: "768px",
                      width: "100%",
                      height: "auto",
                      objectFit: "contain",
                      filter: "drop-shadow(0 25px 60px rgba(0, 0, 0, 0.25))",
                      transition: "all 0.4s ease",
                    }}
                  />
                </div>
              </div>
              <div className="panel">
                <h3>Supported Messaging Channels</h3>
                <div className="channels">
                  <button className="channel primary" onClick={(e) => switchChannel("whatsapp", e)}>
                    WhatsApp
                  </button>
                  <button className="channel" onClick={(e) => switchChannel("messenger", e)}>
                    Messenger
                  </button>
                  <button className="channel" onClick={(e) => switchChannel("viber", e)}>
                    Viber
                  </button>
                </div>
                <div
                  id="channelCopy"
                  style={{ marginTop: "16px", color: "#666", fontSize: "14px", lineHeight: "1.5" }}
                >
                  WhatsApp is ideal for promotional chatbots because of its massive global user
                  base, high message open rates, and native interactive features such as buttons,
                  lists, and location sharing that simplify shopper engagement journeys.
                </div>
              </div>
            </div>
          </section>
          <section className="wrap reveal" id="platform" ref={platformRef}>
            <div className="head">
              <div>
                <div className="eyebrow">Platform</div>
                <h2>A modular promotion stack built for real retail environments.</h2>
              </div>
              <p>
                Kartini combines promotion orchestration, shopper engagement, retailer enablement,
                Image Recognition and analytics in a system that adapts to brand objectives and
                field execution realities.
              </p>
            </div>
            <div className="grid6">
              <div className="panel feature">
                <div className="icon">CP</div>
                <div>
                  <h3>Consumer Promotions</h3>
                  <p>
                    Activate shoppers through QR journeys, media placements and conversational
                    engagement designed to educate, qualify and convert.
                  </p>
                </div>
                <div className="placeholder">WhatsApp journey UI / floating chat preview</div>
              </div>
              <div className="panel feature">
                <div className="icon">TP</div>
                <div>
                  <h3>Trade Promotions</h3>
                  <p>
                    Support retailer participation with clearer mechanics, stronger visibility and
                    more accountable execution.
                  </p>
                </div>
                <div className="placeholder">Retail execution dashboard / campaign controls</div>
              </div>
              <div className="panel feature">
                <div className="icon">DI</div>
                <div>
                  <h3>Display IR</h3>
                  <p>
                    Image Recognition verifying shelf displays, planogram compliance and visual
                    execution standards.
                  </p>
                </div>
                <div className="placeholder">
                  Shelf image / detection overlays / compliance output
                </div>
              </div>
              <div className="panel feature">
                <div className="icon">RI</div>
                <div>
                  <h3>Receipt IR</h3>
                  <p>
                    Image Recognition validating receipt authenticity and transforming receipt
                    content into structured data.
                  </p>
                </div>
                <div className="placeholder">Receipt scan UI / structured extraction card</div>
              </div>
              <div className="panel feature">
                <div className="icon">DK</div>
                <div>
                  <h3>Dompet Kartini</h3>
                  <p>
                    A retailer wallet enabling voucher verification, reimbursement visibility and
                    smoother outlet participation.
                  </p>
                </div>
                <div className="placeholder">Retailer wallet UI / redemption screen</div>
              </div>
              <div className="panel feature">
                <div className="icon">AN</div>
                <div>
                  <h3>Analytics & Reporting</h3>
                  <p>
                    A single view across campaign performance, shopper funnel metrics, retailer
                    activity and Image Recognition outputs.
                  </p>
                </div>
                <div className="placeholder">Dashboard hero / KPI widgets / reporting filters</div>
              </div>
              <div className="panel feature">
                <div className="icon">GWP</div>
                <div>
                  <h3>Gift With Purchase</h3>
                  <p>
                    Manage promotional rewards, qualification rules and claim validation within a
                    structured digital flow.
                  </p>
                </div>
                <div className="placeholder">Gift flow experience placeholder</div>
              </div>
              <div className="panel feature">
                <div className="icon">LP</div>
                <div>
                  <h3>Loyalty Programs</h3>
                  <p>
                    Support repeat engagement through point accumulation, redemption logic and
                    shopper retention mechanics.
                  </p>
                </div>
                <div className="placeholder">Loyalty journey placeholder</div>
              </div>
            </div>
          </section>
          <section className="wrap section-loose reveal" id="technology" ref={technologyRef}>
            <div className="head">
              <div>
                <div className="eyebrow">Platform Intelligence</div>
                <h2>Real-time visibility into promotion performance and retail execution.</h2>
              </div>
              <p>
                Kartini provides brands with a unified command layer to monitor campaign
                performance, shopper engagement and retail compliance in real time.
              </p>
            </div>
            <div className="dash">
              <div className="dashmain">
                <div className="placeholder">Campaign analytics dashboard</div>
                <div className="pills">
                  {DEMO.map((item) => (
                    <span className={`pill ${item.val === demoType && "active"}`}>
                      {item.title}
                    </span>
                  ))}
                </div>
                {/* <div className="bars">
                  <div className="bar" style={{ height: "30%" }}></div>
                  <div className="bar" style={{ height: "46%" }}></div>
                  <div className="bar" style={{ height: "62%" }}></div>
                  <div className="bar" style={{ height: "74%" }}></div>
                  <div className="bar" style={{ height: "86%" }}></div>
                </div> */}
                <div className="page-dash-embed">
                  {currentPage === "home" && <Dashboard key={homeKey} />}
                </div>
              </div>
              <div className="dashside">
                <div className="panel widget">
                  <h3>Interactive Demo</h3>
                  <div className="demo-tabs">
                    {DEMO.map((item) => (
                      <button
                        style={{ fontSize: "11px" }}
                        className={`demo-tab ${item.val === demoType && "active"} ${item.disabled && "disabled"}`}
                        onClick={(e) => {
                          !item.disabled && switchDemo(item.val, e);
                        }}
                      >
                        {item.title}
                      </button>
                    ))}
                  </div>
                  <div className="demo-preview" id="demoPreview">
                    {DEMO.find((item) => item.val === demoType).content}
                  </div>
                </div>
                <div className="panel widget">
                  <h3>Campaign Insights</h3>
                  <p>
                    Track performance across multiple markets, retail channels and shopper segments
                    in a single reporting environment.
                  </p>
                </div>
                <div className="panel widget">
                  <h3>Execution Monitoring</h3>
                  <p>
                    Identify store-level compliance and promotional execution using automated Image
                    Recognition analysis.
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section className="wrap reveal">
            <div className="head">
              <div>
                <div className="eyebrow">WhatsApp Experience</div>
                <h2>
                  Promotion journeys designed for the messaging platforms shoppers already use.
                </h2>
              </div>
              <p>
                Kartini enables brands to deliver multiple promotion mechanics through
                conversational interfaces, making campaigns simple for shoppers while providing
                structured data for brands.
              </p>
            </div>
            <div className="wa-exp">
              <div className="wa-main">
                <div className="wa-phone">
                  <div className="wa-topbar">
                    <div className="wa-avatar">K</div>
                    <div>
                      <strong>Kartini Assistant</strong>
                      <div className="muted-small" id="waModuleLabel">
                        Digital Voucher Distribution
                      </div>
                    </div>
                  </div>
                  <div className="wa-thread" id="waThread">
                    <div className="wa-bubble left">
                      Welcome! Would you like to claim today’s promotion?
                    </div>
                    <div className="wa-bubble right">Yes, show me the available offers.</div>
                    <div className="wa-bubble left">
                      Please select a participating product and nearby store to continue.
                    </div>
                  </div>
                </div>
              </div>
              <div className="wa-side">
                <div className="panel widget">
                  <h3>Interactive Modules</h3>
                  <div className="wa-tabs">
                    <button className="wa-tab active" onClick={(e) => switchWA("voucher", e)}>
                      Digital Voucher Distribution
                    </button>
                    <button className="wa-tab" onClick={(e) => switchWA("gwp", e)}>
                      Gift With Purchase
                    </button>
                    <button className="wa-tab" onClick={(e) => switchWA("loyalty", e)}>
                      Loyalty Points
                    </button>
                    <button className="wa-tab" onClick={(e) => switchWA("vdd", e)}>
                      Visibility and Distribution Drive
                    </button>
                  </div>
                  <div className="wa-caption" id="waCaption">
                    Preview how Kartini guides shoppers through a digital voucher redemption journey
                    using a conversational interface.
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="wrap reveal" id="news" ref={newsRef}>
            <div className="head">
              <div>
                <div className="eyebrow">What’s New at Kartini</div>
                <h2>Latest platform developments, partnerships and market milestones.</h2>
              </div>
              <p>
                Stay updated with Kartini’s newest technology launches, market expansions and
                insights shaping the future of promotion execution.
              </p>
            </div>
            <div className="news-carousel">
              <button
                className="news-nav news-prev"
                onClick={() => newsSliderRef.current?.slickPrev()}
              >
                <svg
                  className="news-nav-icon"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M11.5 5.5L7 10L11.5 14.5"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <button
                className="news-nav news-next"
                onClick={() => newsSliderRef.current?.slickNext()}
              >
                <svg
                  className="news-nav-icon"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M8.5 5.5L13 10L8.5 14.5"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <CaseStudies ref={newsSliderRef} />
            </div>
          </section>
          <section className="wrap reveal" id="customers" ref={customersRef}>
            <div className="head">
              <div>
                <div className="eyebrow">Testimonials</div>
                <h2>Proof from the teams behind high-performance campaigns.</h2>
              </div>
              <p>
                Kartini helps brands turn fragmented campaign activity into a more measurable,
                verifiable and scalable operating model.
              </p>
            </div>
            <div className="grid3">
              <div className="panel testimonial">
                <p className="quote">
                  “Kartini helps us think about promotions as an operating system, not just a
                  campaign mechanic.”
                </p>
                <div className="person">
                  <div className="avatar">A</div>
                  <div>
                    <h3>Client Name Placeholder</h3>
                    <p>Commercial / Marketing Leader</p>
                  </div>
                </div>
              </div>
              <div className="panel testimonial">
                <p className="quote">
                  “The value is not only in the voucher. It is in the visibility, structure and
                  speed of execution.”
                </p>
                <div className="person">
                  <div className="avatar">B</div>
                  <div>
                    <h3>Client Name Placeholder</h3>
                    <p>Sales / Trade Marketing Leader</p>
                  </div>
                </div>
              </div>
              <div className="panel testimonial">
                <p className="quote">
                  “Retail participation becomes more practical when verification and reimbursement
                  are designed into the same flow.”
                </p>
                <div className="person">
                  <div className="avatar">C</div>
                  <div>
                    <h3>Partner Placeholder</h3>
                    <p>Retail / Operations Stakeholder</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="wrap section-loose reveal" id="founders" ref={foundersRef}>
            <div className="head">
              <div>
                <div className="eyebrow">Leadership Team</div>
                <h2>Leadership guiding Kartini’s growth across technology, retail and FMCG.</h2>
              </div>
              <p>
                Kartini’s leadership team brings together commercial, operational, technical and
                regional expertise to support scalable promotion platforms across Indonesia and
                international markets.
              </p>
            </div>
            <div className="grid6">
              <div className="panel founder">
                <div className="photo">
                  <img src="https://cdn.kar-tini.id/hsykal_b2ec7b745e.png" alt="Husain Haykal" />
                </div>
                <div className="copy">
                  <h3>Husain Haykal</h3>
                  <div className="role">Founder & CEO</div>
                </div>
              </div>
              <div className="panel founder">
                <div className="photo">
                  <img src="https://cdn.kar-tini.id/wina_e9df7f7e9f.png" alt="Dewina Aprianasari" />
                </div>
                <div className="copy">
                  <h3>Dewina Aprianasari</h3>
                  <div className="role">Head of Accounts - ID</div>
                </div>
              </div>
              <div className="panel founder">
                <div className="photo">
                  <img src="https://cdn.kar-tini.id/steve_3780e3e1b7.png" alt="Steve Leonardy" />
                </div>
                <div className="copy">
                  <h3>Steve Leonardy</h3>
                  <div className="role">Head of Operations</div>
                </div>
              </div>
              <div className="panel founder">
                <div className="photo">
                  <img src="https://cdn.kar-tini.id/abud_0f324251d3.png" alt="Hary M. Nugraha" />
                </div>
                <div className="copy">
                  <h3>Hary M. Nugraha</h3>
                  <div className="role">CTO</div>
                </div>
              </div>
              <div className="panel founder">
                <div className="photo">
                  <img src="https://cdn.kar-tini.id/dunc_5404e9ba02.png" alt="Duncan Gates" />
                </div>
                <div className="copy">
                  <h3>Duncan Gates</h3>
                  <div className="role">GM-APAC</div>
                </div>
              </div>
              <div className="panel founder">
                <div className="photo">
                  <img src="https://cdn.kar-tini.id/mari_df193a250d.png" alt="Marissa K. Thalib" />
                </div>
                <div className="copy">
                  <h3>Marissa K. Thalib</h3>
                  <div className="role">International BD & Accounts Director</div>
                </div>
              </div>
              <div className="panel founder">
                <div className="photo">
                  <img src="https://cdn.kar-tini.id/reza_0c2ed16343.png" alt="Muhammad Reza" />
                </div>
                <div className="copy">
                  <h3>Muhammad Reza</h3>
                  <div className="role">Commercial Advisor</div>
                </div>
              </div>
              <div className="panel founder">
                <div className="photo">
                  <img
                    src="https://cdn.kar-tini.id/pelita_2eca5c6f0b.png"
                    alt="Pelitawan Tjandrasa"
                  />
                </div>
                <div className="copy">
                  <h3>Pelitawan Tjandrasa</h3>
                  <div className="role">Technical Advisor</div>
                </div>
              </div>
            </div>
          </section>
          <section className="wrap reveal">
            <div className="head">
              <div>
                <div className="eyebrow">Trusted by Leading FMCG Companies</div>
                <h2>
                  Built to support modern promotion programs across brands, channels and markets.
                </h2>
              </div>
              <p>
                Kartini works with leading manufacturers and consumer brands to connect shopper
                engagement, retail execution and promotion visibility in one scalable platform.
              </p>
            </div>
            <div className="grid3" style={{ marginBottom: "24px" }}>
              <div className="panel badge-card">
                <div>
                  <div className="badge-kicker">Scale</div>
                  <div className="badge-value">Nationwide campaign deployment</div>
                </div>
                <p style={{ fontSize: "14px" }}>
                  Launch consumer and trade promotion programs across multiple channels, stores and
                  markets with greater operational consistency.
                </p>
              </div>
              <div className="panel badge-card">
                <div>
                  <div className="badge-kicker">Visibility</div>
                  <div className="badge-value">Real-time reporting and verification</div>
                </div>
                <p style={{ fontSize: "14px" }}>
                  Track shopper journeys, redemptions and retail execution through a live reporting
                  layer supported by Image Recognition.
                </p>
              </div>
              <div className="panel badge-card">
                <div>
                  <div className="badge-kicker">Impact</div>
                  <div className="badge-value">Measurable retail and shopper outcomes</div>
                </div>
                <p style={{ fontSize: "14px" }}>
                  Drive better promotional accountability across brands, retailers and field teams
                  with structured data and clearer performance signals.
                </p>
              </div>
            </div>
            <div className="cta">
              <div className="eyebrow">Get Started</div>
              <h2>Transform the way promotions connect brands, retailers and shoppers.</h2>
              <p>
                Deploy nationwide consumer and trade promotions faster, gain real-time retail
                visibility, and drive measurable growth across your distribution network with
                Kartini.
              </p>
              <div className="hero-actions" style={{ justifyContent: "center" }}>
                <button className="btn dark" onClick={(e) => showPage("demo")}>
                  Book a Demo
                </button>
                <button className="btn" onClick={(e) => showPage("contact")}>
                  Contact Us
                </button>
              </div>
            </div>
          </section>
        </main>
      </div>
      <div id="demo" className="page">
        <main className="wrap formwrap">
          <div className="formhero">
            <div className="eyebrow">Book Demo</div>
            <h1>See how Kartini could work for your business.</h1>
            <p>
              Ready to step up your promotion game and modernise your consumer and trade promotions?
              Contact us today.
            </p>
          </div>
          <div className="panel formcard">
            <h2>Contact Details</h2>
            <p style={{ color: "#666" }}>Fill in the details below to request a demo.</p>
            <div className="formgrid">
              <div className="field">
                <label>Full Name</label>
                <input type="text" placeholder="Your full name" />
              </div>
              <div className="field">
                <label>Company</label>
                <input type="text" placeholder="Your company name" />
              </div>
              <div className="field">
                <label>Role / Title</label>
                <input type="text" placeholder="Your job title" />
              </div>
              <div className="field">
                <label>Email Address</label>
                <input type="email" placeholder="name@company.com" />
              </div>
              <div className="field">
                <label>Phone Number</label>
                <input type="text" placeholder="+62..." />
              </div>
              <div className="field">
                <label>Country</label>
                <select>
                  <option>Indonesia</option>
                  <option>Malaysia</option>
                  <option>Philippines</option>
                  <option>Singapore</option>
                  <option>Other</option>
                </select>
              </div>
              <div className="field full">
                <label>Primary Interest</label>
                <select>
                  <option>Consumer Promotions</option>
                  <option>Trade Promotions</option>
                  <option>Display IR</option>
                  <option>Receipt IR</option>
                  <option>Dompet Kartini</option>
                  <option>Full Platform</option>
                </select>
              </div>
              <div className="field full">
                <label>Message</label>
                <textarea placeholder="Tell us about your business, campaign needs or reporting requirements."></textarea>
              </div>
            </div>
            {/* <div className="note">
              Prototype note: this submit button is visual only. Later this can connect to your CRM,
              contact email, Google Sheets, HubSpot or Calendly workflow.
            </div> */}
            <div className="hero-actions" style={{ marginTop: "30px" }}>
              <button
                className="btn dark"
                onClick={(e) => alert("Demo request submitted (prototype only).")}
              >
                Submit Demo Request
              </button>
              <button className="btn" onClick={(e) => showPage("home")}>
                Back to Home
              </button>
            </div>
          </div>
        </main>
      </div>
      <div id="signin" className="page">
        <main className="wrap formwrap">
          <div className="formhero">
            <div className="eyebrow">Client Sign In</div>
            <h1>Access your reports and platform views.</h1>
            <p>Your command center for end-to-end consumer and trade promotion performance.</p>
          </div>
          <div className="panel formcard">
            <h2>Sign In to Your Account</h2>
            <p style={{ color: "#666" }}>Use your registered email and password to continue.</p>
            <div className="formgrid">
              <div className="field full">
                <label>Email Address</label>
                <input type="email" placeholder="name@company.com" />
              </div>
              <div className="field full">
                <label>Password</label>
                <input type="password" placeholder="Enter your password" />
              </div>
            </div>
            <div className="signinmeta" style={{ marginTop: "2rem" }}>
              {/* <div className="meta">
                <strong>MFA Required</strong>
                <p>
                  For production use, this sign-in flow should include Multi-Factor Authentication
                  for added security.
                </p>
              </div> */}
              {/* <div className="meta">
                <strong>Prototype Note</strong>
                <p>
                  This page is a visual prototype only and does not connect to a real authentication
                  system yet.
                </p>
              </div> */}
            </div>
            <div className="hero-actions">
              <button
                className="btn dark"
                onClick={(e) =>
                  alert(
                    "Sign in flow placeholder. MFA step would appear after password verification.",
                  )
                }
              >
                Sign In
              </button>
              <button className="btn" onClick={(e) => showPage("home")}>
                Back to Home
              </button>
            </div>
          </div>
        </main>
      </div>
      <Footer />
    </>
  );
}

export default App;
